<div class="col col-lg-3 mx-auto">
    <div class="row g-0 my-1">
        <h1 class="text-center">Unauthorized</h1>
    </div>
    <div class="row g-0 my-1">
        <span class="text-center font-size-16">You are not authorized to access this page.</span>
    </div>
</div>